<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-date-picker
                    :end-validations="validations.periodoContabil"
                    :range-inline="false"
                    :start-validations="validations.periodoContabil"
                    end-label="Até"
                    range
                    start-label="Período de"
                    v-model="model.periodoContabil"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Moment.
import moment from 'moment'

export default {
    computed: {
        validations() {
            return {
                periodoContabil: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            periodoContabil: this.getConectaSusRepository('webService.almoxarifado.cliente.periodoContabil'),
        }
    },
    data: () => ({
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.periodoContabil.create()
                .then(response => {
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        inicio: this.others.moment(this.model.periodoContabil.start).format('YYYY-MM-DD'),
                        fim: this.others.moment(this.model.periodoContabil.end).format('YYYY-MM-DD'),
                    }

                    this.repositories.periodoContabil.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('saved', response)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
}
</script>